import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";

export const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const URL_CARNET = process.env.REACT_APP_APIURL;
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email || !password) {
      Swal.fire({
        title: '<strong style="color:#EDEEEF;">Lo sentimos</strong>',
        icon: "error",
        html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Faltan datos necesarios</font></p> ',
        background: "#1E4775",
        showConfirmButton: false,
        showCloseButton: true,
      });
      return;
    }

    try {
      const response = await axios.post(URL_CARNET + "/autenticacion", {
        Usuario: email,
        Clave: password,
        System: "CARNETIZACION",
      });
      const { Carnet } = response?.data?.Datos;
      localStorage.setItem("token", response?.data?.Message);
      localStorage.setItem("cmac", response?.data?.Cmac);
      localStorage.setItem("carnet", Carnet);
      navigate("/carnet");
      return;
    } catch (error) {
      if (error?.code === "ERR_BAD_REQUEST") {
        Swal.fire({
          title:
            '<strong style="color:#EDEEEF;"> USUARIO O CONTRASEÑA INCORRECTO </strong>',
          icon: "warning",
          html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Revisa tus credenciales y vuelve a intentarlo</font></p> ',
          background: "#1E4775",
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else {
        Swal.fire({
          title: '<strong style="color:#EDEEEF;"> LO SENTIMOS </strong>',
          icon: "error",
          html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Existe un problema con el recurso solicitado, comunicate al 2209 - 2834 </font></p> ',
          background: "#1E4775",
          showConfirmButton: false,
          showCloseButton: true,
        });
      }
      console.error(error);
    }
  };

  return (
    <div>
      <Header />
      <div className="container pt-5 mt-5">
        <div className="row bg-blue pt-5 pb-5 rounded-1">
          <div className="col-md-7 d-flex align-items-center justify-content-center">
            <div className="text-white text-center">
              <h1 className="display-5">INICIA SESIÓN</h1>
              <p className="h3">
                Recuerda utilizar tu email institucional <br />y contraseña de
                WebDesktop
              </p>
            </div>
          </div>
          <div className="col-md-5">
            <form
              onSubmit={handleSubmit}
              method="POST"
              className="bg-white p-5 rounded-1"
            >
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email (UFG) *
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  placeholder="Email"
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Clave (WebDesktop) *
                </label>
                <input
                  name="password"
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  className="form-control"
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 p-2 text-uppercase"
              >
                Ingresar
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
